import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";
import {useSelector} from "react-redux";

export const useCzyMoznaInicjowac = (rejestrId, enabled = true) => {
    const rola = useSelector((state) => state.user.role);
    const roleParam = rola === 'oper' ? 'oper/' : '';

    return useQuery({
        queryKey: [`czy_mozna_inicjowac`, rejestrId],
        queryFn: () => getData(`/${roleParam}sprawozdanie/czy-mozna-inicjowac/${rejestrId}`),
        enabled: enabled && !!rejestrId
    })
}
